import { createAction } from "@reduxjs/toolkit";
import type { AdminTrainingFollowUpVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveTrainingFollowUp = createApiThunk<AdminTrainingFollowUpVM, string>(
  "trainingFollowUps/adminRetrieveTrainingFollowUp",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.adminGetOne(id);
  },
);

export const resetAdminRetrieveTrainingFollowUp = createAction("trainingFollowUps/adminResetRetrieveTrainingFollowUp");
